export enum RegisterStepEnum {
  stepSignUp = 'stepSignUp',
  step1 = 'step1',
  step2 = 'step2',
  step3 = 'step3',
  step4 = 'step4',
}

export enum RegisterGtmStepNameEnum {
  emailPassword = 'email_password',
  personalInformation = 'personal_information',
  crmSelection = 'crm_selection',
  companyInformation = 'company_information',
  countrySelection = 'country_selection',
  creditCardEntry = 'credit_card_entry',
}

export enum RegisterGtmStepNumberEnum {
  emailPassword = 1,
  companyInformation = 2,
  crmSelection = 3,
  countrySelection = 4,
  creditCardEntry = 5,
}

export type IGtmAnswers = {
  step: RegisterStepEnum
  email: string | null
  phone: string | null
  crm: string | null
  contacts_number: string | null
  company_size: string | null
  role: string | null
  first_message_country: string | null
  plan: string | null
  userId: number | null
}

type IGtmAnswersCommonParams = {
  event: 'registration_funnel_step'
  step_name: RegisterGtmStepNameEnum
  step_number: RegisterGtmStepNumberEnum
  email: string | null
}

export type IGtmAnswersStep1Params = IGtmAnswersCommonParams

export type IGtmAnswersStep2Params = IGtmAnswersCommonParams & {
  phone: string | null
}

export type IGtmAnswersStep3Params = IGtmAnswersStep2Params & {
  crm: string | null
  contacts_number: string | null
}

export type IGtmAnswersStep4Params = IGtmAnswersStep3Params & {
  company_size: string | null
  role: string | null
}

export type IGtmAnswersStep5Params = IGtmAnswersStep4Params & {
  first_message_country: string | null
}

export type IGtmAnswersStep6Params = IGtmAnswersStep5Params & {
  plan: string | null
  userId: number | null
}

export type IGtmAnswersAllSteps = IGtmAnswersStep1Params &
  IGtmAnswersStep2Params &
  IGtmAnswersStep3Params &
  IGtmAnswersStep4Params &
  IGtmAnswersStep5Params &
  IGtmAnswersStep6Params
